module.exports = __webpack_public_path__ + "static/media/red-heart.6c89c7ee.svg";